import { useCallback } from 'react';
import {
  DocumentsEventLabels,
  DocumentsEventsMap,
  type TrackDocumentsEvent,
} from 'src/modules/analytics/useTrackAnalytics/domains/documents/events';
import { useTrackEvent } from 'src/modules/analytics/useTrackAnalytics/useTrackAnalytics';
import { useOptionalRouteParam } from '@/common/hooks/useOptionalRouteParam';

/**
 * Custom hook to handle documents tracking events
 */
export function useTrackDocsAnalytics() {
  const trackEvent = useTrackEvent();
  const documentId = useOptionalRouteParam('documentId');

  return useCallback(
    (event: TrackDocumentsEvent, extra?: Record<string, unknown>) => {
      const eventLabel = DocumentsEventLabels[event];
      const eventInfo = DocumentsEventsMap[event];
      trackEvent(eventLabel, {
        ...eventInfo,
        ...(documentId ? { documentId } : {}),
        ...extra,
      });
    },
    [trackEvent, documentId],
  );
}
